import React from "react";
import t from '../../../helpers/t';

import * as BatteryLevel from "../styled_components/BatteryLevel"
import { Biscuit } from "../../../../utils";


const batteryIcon = (props) => {
    let activated = Biscuit.get('lock_activated') === "true";
    let title = t('lock_battery', null, 'capital');
    if (typeof props.Resource.lock_state !== 'undefined' && props.Resource.ilockit_device_id !== null) {
        title = props.Resource.lock_state === 'open' ? t('close_lock', null, 'capital') : t('open_lock', null, 'capital');
    }
    let title2 = t('resource_battery', null, 'capital');
    let half = "fi fi-battery-half battery-half";
    let full = "fi fi-battery-full battery--full";
    let empty = "fi fi-battery-empty battery--empty";
    let fullEmpty = "fi fi-battery-full battery--empty";
    let accuState;
    switch (props.Value) {
        case (props.Value > 70):
            accuState = full;
            break;
        case (props.Value > 40):
            accuState = half;
            break;
        case (props.Value >= 0):
            accuState = empty;
            break;
        default:
            accuState = fullEmpty;
            break;
    }

    if(Biscuit.get('user.role') !== 'admin' || !activated){
        title = t('lock_battery', null, 'capital');
    }

    if (props.Name === 'bike') {
        title = title2;
    }
    let marginRightValue = '8px';
    if(typeof props.small !== 'undefined' && props.small){
        marginRightValue = '2px';
    }
    if (props.Name === 'lock') {
        return (
            <>
                {(Biscuit.get('user.role') === 'admin' && activated && props.Resource.ilockit_device_id !== null && props.Resource.online)?
                <>
                    {props.locked ?
                        <>
                            <img style={{float: "left", width: "20px", height: "20px", display: "flex", background: "gray", marginRight: "8px"}} className="rollingLoader" alt="rollingLoader" src={"assets/img/rolling_loader.svg"}/>
                            </>
                    : <><a href='#' onClick={() => props.EventHandler(props.Resource)}
                                           key={"icon_a_resource_button_lock_" + props.Resource.id}>
                        <div
                            title={title}
                            style={{float: 'left', marginRight:marginRightValue}}
                            key={"icon_div_resource_button_lock_"+props.Resource.id}>
                            <BatteryLevel.LockBatteryLevel
                                batteryValue={props.Value}
                                lockState={props.Resource.lock_state}
                                showPercentage={props.showPercent}
                                style={{}}
                                online={props.Resource.online}
                            />
                        </div>
                    </a>
                    </>
                    }
                    </>
                : <>
                <div
                    title={(!props.Resource.online?t('lock_battery', null, 'capital')+' (Offline)':title)}
                    style={{float: 'left', marginRight:marginRightValue}}
                    key={"icon_div_resource_button_lock_"+props.Resource.id}>
                    <BatteryLevel.LockBatteryLevel
                        batteryValue={props.Value}
                        lockState={props.Resource.lock_state}
                        showPercentage={props.showPercent}
                        style={{}}
                        online={props.Resource.online}
                    />
                </div>
            </>
                    }
                </>
        );
    } else {
        return (<>
            <div title={title2} style={{float: 'left', display: "flex"}} key={"icon2_div_resource_button_lock_"+props.Resource.id}>
            <BatteryLevel.BikeBatteryLevel
                batteryValue={props.Value}
                showPercentage={props.showPercent}
                style={{}}
            />
            </div>
        </>);
    }
}

export default batteryIcon;

